// src/hooks/useListLastThreeNotifications.ts
import useNotificationStore from '../store/api/useNotificationStore';

export const useLastThreeNotifications = () => {
  const { notifications, totalUnRead, isLoading, error, listLastThreeNotifications } = useNotificationStore();

  return { notifications, totalUnRead, isLoading, error, listLastThreeNotifications };
};
